import React, { Component } from 'react';
import './styles.css';

class BannerImage extends Component {
  render(){
    return (
      <div className="banner-image-container">
        <div className="banner-image-headeline" style={{backgroundImage:"url(" + this.props.image2 + ")"}}>
          <div>
            <span className="location">{this.props.location || 'Barcelona'}</span>
            <span className="description">{this.props.description || 'GIVE BACK THROUGH TECH'}</span>
            <span className="date">{this.props.daterange || ''}</span>
          </div>
        </div>
        <div className="banner-image" style={{backgroundImage:"url(" + this.props.image + ")"}}>
          <div className="adidas-hackathons"><div><img src="/img/header-v-adidas-hackathons.png" alt="adidas hackathons 2018" /></div></div>
        </div>
      </div>
    );
  }
}

export default BannerImage;



// WEBPACK FOOTER //
// ./src/components/BannerImage/BannerImage.js